import { Component, type ErrorInfo, type ReactNode } from 'react'
import { createNadDebug } from '../utils/debugLog'

const nuxLog = createNadDebug('dw:nux-tooltips')

interface Props {
  children: ReactNode
  fallback: ReactNode
}

interface State {
  failed: boolean
}

export class NuxTooltipBoundary extends Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    nuxLog({
      event: 'boundary-error',
      feature: 'nux-tooltips',
      error_name: error.name,
      component_stack_len: info.componentStack?.length ?? 0,
    })
  }

  render() {
    if (this.state.failed) return this.props.fallback
    return this.props.children
  }
}
